import SyncableModel from './SyncableModel';

export default class Activity extends SyncableModel {
  static name = 'Activity'

  _table = 'activity_logs'

  _fillable = [
    'id',
    'log_name',
    'description',
    'subject_id',
    'subject_type',
    'causer_id',
    'causer_type',
    'properties',
    'created_at', 'updated_at',
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    subject_id: 'integer',
    causer_id: 'integer',
    properties: 'object'
  }

  static endpoint = '/activities'

  static online = true
}
